var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00376 19.1449C16.7964 19.1449 21.6069 11.9709 21.6069 5.75155C21.6069 5.54987 21.6024 5.34371 21.5933 5.14203C22.5291 4.47571 23.3366 3.65039 23.978 2.70483C23.1065 3.08661 22.1812 3.33595 21.2336 3.44433C22.2313 2.85552 22.9783 1.93054 23.3362 0.840854C22.3976 1.38851 21.3712 1.77483 20.3009 1.98326C19.5798 1.22884 18.6264 0.729323 17.588 0.56194C16.5496 0.394558 15.4841 0.568633 14.5563 1.05725C13.6284 1.54587 12.8899 2.32182 12.4549 3.26513C12.0199 4.20844 11.9127 5.26657 12.1497 6.27592C10.2492 6.18202 8.39004 5.69595 6.69262 4.84921C4.99519 4.00247 3.49745 2.81396 2.29648 1.36074C1.68608 2.39691 1.4993 3.62303 1.77409 4.78992C2.04889 5.95681 2.76464 6.9769 3.77587 7.64287C3.0167 7.61914 2.27415 7.41789 1.60958 7.05575V7.11402C1.6089 8.2014 1.99071 9.25545 2.6901 10.097C3.38949 10.9386 4.3633 11.5157 5.446 11.7303C4.74274 11.9197 4.00464 11.9473 3.28881 11.8109C3.59433 12.7461 4.18875 13.564 4.98912 14.1505C5.78949 14.737 6.75587 15.0629 7.7534 15.0826C6.0599 16.3924 3.96792 17.1028 1.81442 17.0994C1.43252 17.0989 1.05099 17.0758 0.671875 17.0304C2.8596 18.4123 5.40451 19.1463 8.00376 19.1449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d89d23a58512dbaf750df8f4bfa43c55.svg";
export { ForwardRef as ReactComponent };